var App = App || {};

App.PrimaryNavigation = (function ($) {
    "use strict";

    function init() {
        $(window).on('load', SetMenuSize);
        $(window).resize(SetMenuSize);
        $(document).on('keydown', function (event) {
            if (event.key == "Escape") {
                $(".primary-navigation :focus").blur();
            }
        });
    }

    function SetMenuSize() {
        $(".primary-navigation .menu-container > div").each(function () {
            $(this).parent().width($(this).outerWidth());
            $(this).parent().height($(this).outerHeight());
        });;
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.PrimaryNavigation.init();
});